import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const apiGetRutas = () => {
  return request(API_ROUTES.getRoutes, {
    method: "GET",
  });
};

export const apiGetConsecutivos = () => {
  return request(API_ROUTES.consecutivo, {
    method: "GET",
  });
};

export const apiSaveRuta = (payload) => {
  const isUpdate = !!payload.id;
  return request(API_ROUTES.saveRoutesPYM, {
    method: isUpdate ? "PUT" : "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};

export const getRoutesById = async (id) => {
  const res = await request(API_ROUTES.getRoutesById(id), { method: "GET" });
  return await res.json();
};

export const saveRoute = async (form) => {
  const isUpdate = !!form.id;
  const res = await request(API_ROUTES.saveRoute, {
    method: isUpdate ? "PUT" : "POST",
    body: JSON.stringify(form),
  });

  return res.json();
};
